/**
 * DECOMURA CUSTOM: Smart Filters — Active state detection + Heart Sort
 * Highlights the currently active filter based on URL params
 * Adds "❤️ Popularne" to native Shopify sort dropdown
 * Persists the option after Shopify AJAX navigation
 * 
 * v2.0 — Faza 3 Performance Optimization:
 *   - 3 MutationObservery → 1 unified observer (debounced)
 *   - Usunięto polling setInterval
 *   - Event-driven heart sort init
 */
(function() {
  'use strict';
  if (window.__dcmSmartFiltersInit) return;
  window.__dcmSmartFiltersInit = true;

  // --- Configuration ---
  const HEART_SORT_VALUE = 'hearts-desc';
  

  // Teksty pochodzą z sześciu plików locales, przekazanych przez Liquid.
  let dcmTexts = {};
  try { dcmTexts = JSON.parse(document.getElementById('dcm-staging-i18n').textContent); } catch (_) {}
  function dcmText(key, values) {
    let value = dcmTexts[key] || '';
    Object.keys(values || {}).forEach(name => { value = value.replaceAll('[' + name + ']', String(values[name])); });
    return value;
  }

  const HEART_SORT_LABEL = dcmText('popular');

  function isDcmCollection() {
    return Boolean(document.querySelector('[data-dcm-collection]'));
  }

  // Adres wyszukiwarki Shopify domyślnie nie ma parametru sortowania, a brak parametru oznacza tam
  // trafność wybraną przez serwer — nie nasze „Popularne”. Bez tego każde wyszukanie było po cichu
  // przestawiane po sercach, a artykuły bloga bez licznika lądowały na końcu.
  function jestWyszukiwarka() {
    return /(^|\/)search$/.test(window.location.pathname);
  }

  // --- State ---
  let isHeartSortActive = false;
  let isSorting = false;
  let heartRefreshGrid = null;

  // ==========================================================================
  // 1. HIGHLIGHT ACTIVE TAG FILTERS
  // ==========================================================================
  function highlightActiveFilters() {
    const currentParams = new URLSearchParams(window.location.search);
    const currentTags = currentParams.getAll('filter.p.tag');
    
    const currentTagSet = new Set(currentTags.map(t => t.toLowerCase()));

    document.querySelectorAll('.smart-filter[href]').forEach(filter => {
      try {
        // 28.09.2026: tagi filtra czytamy z pierwotnego adresu — aktywny filtr dostaje adres „zdejmij”.
        if (!filter.dataset.dcmHrefOn) filter.dataset.dcmHrefOn = filter.getAttribute('href');
        const filterUrl = new URL(filter.dataset.dcmHrefOn, window.location.origin);
        const filterParams = new URLSearchParams(filterUrl.search);
        const filterTags = filterParams.getAll('filter.p.tag');

        if (filterTags.length === 0) return;

        const isActive = filterTags.length > 0 && 
          filterTags.every(t => currentTagSet.has(t.toLowerCase()));

        filter.classList.toggle('smart-filter--active', isActive);
        // 28.09.2026: surowe „pigułki” tagów są schowane (decyzja właściciela) — aktywny filtr zdejmuje się kliknięciem (×).
        // Atrybuty zmieniamy tylko przy różnicy, a znaczek dodajemy raz — obserwator DOM nie zapętli się.
        let dcmX = filter.querySelector('.dcm-sf-zdejmij');
        if (isActive) {
          const off = new URL(window.location.href);
          const mine = new Set(filterTags.map(t => t.toLowerCase()));
          const keep = off.searchParams.getAll('filter.p.tag').filter(t => !mine.has(t.toLowerCase()));
          off.searchParams.delete('filter.p.tag');
          keep.forEach(t => off.searchParams.append('filter.p.tag', t));
          off.searchParams.delete('page');
          const offHref = off.pathname + off.search;
          if (filter.getAttribute('href') !== offHref) filter.setAttribute('href', offHref);
          if (filter.getAttribute('aria-pressed') !== 'true') filter.setAttribute('aria-pressed', 'true');
          if (!dcmX) {
            dcmX = document.createElement('span');
            dcmX.className = 'dcm-sf-zdejmij';
            dcmX.setAttribute('aria-hidden', 'true');
            dcmX.textContent = ' ×';
            filter.appendChild(dcmX);
          }
        } else {
          if (filter.getAttribute('href') !== filter.dataset.dcmHrefOn) filter.setAttribute('href', filter.dataset.dcmHrefOn);
          if (filter.hasAttribute('aria-pressed')) filter.removeAttribute('aria-pressed');
          if (dcmX) dcmX.remove();
        }
      } catch (e) {
        // Ignore invalid URLs
      }
    });
  }

  // ==========================================================================
  // 2. INJECT HEART SORT INTO NATIVE SHOPIFY DROPDOWN
  // ==========================================================================
  function sortSelects() {
    return document.querySelectorAll('facet-filters-form select[name="sort_by"]');
  }

  function syncSortFromUrl() {
    if (isDcmCollection()) { isHeartSortActive = false; return; }
    const value = new URLSearchParams(window.location.search).get('sort_by');
    isHeartSortActive = value ? value === HEART_SORT_VALUE : !jestWyszukiwarka();
    // Bez jawnej wartości nie dotykamy listy: wybór serwera ma zostać widoczny dla klienta.
    sortSelects().forEach(select => {
      if (isHeartSortActive) select.value = HEART_SORT_VALUE;
      else if (value !== null) select.value = value;
    });
  }

  function injectHeartSortOption() {
    if (isDcmCollection()) { isHeartSortActive = false; return; }
    let added = false;
    sortSelects().forEach(select => {
      if (!select.querySelector('option[value="' + HEART_SORT_VALUE + '"]')) {
        const option = document.createElement('option');
        option.value = HEART_SORT_VALUE;
        option.textContent = HEART_SORT_LABEL;
        select.prepend(option);
        added = true;
      }
      ensureSortListener(select);
    });
    // Zachowujemy natywne opcje Shopify (w tym trafność wyszukiwania).
    if (added) syncSortFromUrl();
  }

  function ensureSortListener(select) {
    if (select._heartListenerAttached) return;
    select._heartListenerAttached = true;
    const onSort = function(e) {
      if (isDcmCollection()) return;
      const wasActive = isHeartSortActive;
      isHeartSortActive = select.value === HEART_SORT_VALUE;
      sortSelects().forEach(other => { if (other !== select) other.value = select.value; });
      if (!isHeartSortActive) return; // Sortowania natywne obsługuje Dawn.
      e.preventDefault();
      e.stopPropagation();
      const url = new URL(window.location.href);
      const previousSort = url.searchParams.get('sort_by');
      url.searchParams.delete('sort_by');
      const state = Object.assign({}, window.history.state || {}, { searchParams: url.search.slice(1) });
      if (!wasActive) {
        delete state.dcmHeartOrder;
        document.querySelectorAll('#product-grid [data-dcm-heart-placed]').forEach(item => { delete item.dataset.dcmHeartPlaced; });
      }
      if (!wasActive && previousSort && previousSort !== HEART_SORT_VALUE) {
        // Inna kolejność Shopify oznacza też inny zestaw produktów na danej stronie.
        // Pobieramy zestaw zgodny z nowym URL, aby Wstecz i odświeżenie go odtwarzały.
        const form = select.closest('facet-filters-form');
        if (form && typeof form.onSubmitForm === 'function') {
          heartRefreshGrid = document.getElementById('product-grid');
          form.onSubmitForm(url.searchParams.toString(), e);
          return;
        }
        window.location.assign(url.toString());
        return;
      }
      window.history.replaceState(state, '', url);
      sortProductsByHearts();
    };
    // Dawn nasłuchuje input, a nie change. Oba zdarzenia muszą zachować ten sam wybór.
    select.addEventListener('input', onSort, true);
    select.addEventListener('change', onSort, true);
  }

  /**
   * Kontener, do którego wolno dopinać kafle.
   * Na kolekcji #product-grid to samo <ul>, ale na WYSZUKIWARCE to <div class="template-search__results">,
   * w którym lista jest dopiero wewnątrz. Dopinanie <li> do <div> wyrzucało je poza <ul>:
   * kafle stawały się elementami listy bez listy (punktator, jedna kolumna, paginacja nad wynikami).
   */
  function getSortList(grid) {
    if (grid.matches('ul')) return grid;
    return grid.querySelector('ul.product-grid') || grid.querySelector('ul.grid') || grid.querySelector('ul');
  }

  function orderKey(item) {
    return item.querySelector('.wishlist-badge')?.dataset.productHandle || item.querySelector('a[href]')?.getAttribute('href') || '';
  }

  function saveHeartOrder(list) {
    // Historia przechowuje tylko klucze i kolejność, nigdy HTML, ceny ani stan serc.
    const state = Object.assign({}, window.history.state || {}, {
      searchParams: window.location.search.slice(1),
      dcmHeartOrder: {
        key: window.location.pathname + window.location.search,
        items: Array.from(list.children).filter(el => el.classList.contains('grid__item')).map(orderKey)
      }
    });
    // Podczas odtwarzania kolejnych porcji zachowujemy także ich zapisaną kolejność.
    const pending = window.history.state?.dcmListing;
    const listPage = Number(list.dataset.page);
    const previous = window.history.state?.dcmHeartOrder;
    if (pending?.lastPage > listPage && previous?.key === state.dcmHeartOrder.key) {
      state.dcmHeartOrder.items.push(...previous.items.filter(key => !state.dcmHeartOrder.items.includes(key)));
    }
    window.history.replaceState(state, '', window.location.href);
  }

  function sortProductsByHearts() {
    if (isDcmCollection() || !isHeartSortActive || isSorting) return;
    if (heartRefreshGrid && heartRefreshGrid.isConnected) return;
    heartRefreshGrid = null;
    const grid = document.getElementById('product-grid');
    const list = grid && getSortList(grid);
    if (!list) return;
    const items = Array.from(list.children).filter(el => el.classList.contains('grid__item'));
    const fresh = items.filter(el => !el.dataset.dcmHeartPlaced);
    if (!fresh.length) return;
    const key = window.location.pathname + window.location.search;
    const saved = window.history.state?.dcmHeartOrder;
    const previous = saved?.key === key && Array.isArray(saved.items) ? saved.items : [];
    const ranks = new Map(previous.map((handle, i) => [handle, i]));
    const canRestore = fresh.every(item => ranks.has(orderKey(item)));
    // Zero też jest poprawnym wynikiem. Nie wolno mylić go z brakiem odpowiedzi ERP
    // ani ustalać kolejności na podstawie pierwszego optymistycznego kliknięcia.
    if (!canRestore && fresh.some(item => Array.from(item.querySelectorAll('.wishlist-badge')).some(b => b.dataset.dcmCountsReady !== 'true'))) return;
    const sorted = fresh.map((element, index) => ({ element, index, count: parseInt(element.querySelector('.wishlist-count')?.textContent, 10) || 0 }));
    sorted.sort((a, b) => canRestore
      ? ranks.get(orderKey(a.element)) - ranks.get(orderKey(b.element))
      : b.count - a.count || a.index - b.index);
    sorted.forEach(({element}) => { element.dataset.dcmHeartPlaced = '1'; });
    if (sorted.some(({element}, i) => element !== fresh[i])) {
      isSorting = true;
      const fragment = document.createDocumentFragment();
      sorted.forEach(({element}) => fragment.appendChild(element));
      list.appendChild(fragment);
      requestAnimationFrame(() => { isSorting = false; });
    }
    saveHeartOrder(list);
  }

  // ==========================================================================
  // 4. LISTEN FOR HEART COUNTS TO LOAD (event-driven, no polling)
  // ==========================================================================
  function listenForHeartCounts() {
    // Kliknięcie może wyprzedzić pierwszą odpowiedź /counts. Od tego momentu
    // zachowujemy oglądaną kolejność, również gdy dopiero nadejdą liczniki.
    document.addEventListener('click', event => {
      if (isDcmCollection() || !isHeartSortActive || !(event.target instanceof Element)) return;
      const button = event.target.closest('.wishlist-btn');
      const grid = document.getElementById('product-grid');
      const list = grid && getSortList(grid);
      if (!button || !list || !list.contains(button)) return;
      Array.from(list.children).filter(el => el.classList.contains('grid__item')).forEach(item => {
        item.dataset.dcmHeartPlaced = '1';
      });
      saveHeartOrder(list);
    }, true);
    // Primary: Listen for custom event from collection-heart.js
    document.addEventListener('decomura:hearts-loaded', () => {
      if (isHeartSortActive) {
        sortProductsByHearts();
      }
    });

    // One-shot check: if hearts are already loaded (race condition guard)
    // Uses requestIdleCallback to avoid blocking main thread
    const checkOnce = () => {
      if (!isHeartSortActive) return;
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      sortProductsByHearts();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(checkOnce, { timeout: 2000 });
    } else {
      setTimeout(checkOnce, 500);
    }
  }

  // ==========================================================================
  // 5. UNIFIED MUTATION OBSERVER (single observer, debounced)
  // ==========================================================================
  function observeForChanges() {
    // Find the broadest container that covers both grid and facets
    const collectionContainer = document.getElementById('MainContent') || document.body;

    let debounceTimer;
    const DEBOUNCE_MS = 150;

    const unifiedObserver = new MutationObserver((mutations) => {
      // Skip mutations triggered by our own sorting
      if (isSorting) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Re-inject heart sort option (may have been replaced by Shopify AJAX)
        injectHeartSortOption();
        // Re-intercept form submission
        interceptSortForm();
        // Re-highlight active filters
        highlightActiveFilters();
        // Re-sort by hearts if active
        if (isHeartSortActive) {
          sortProductsByHearts();
        }
      }, DEBOUNCE_MS);
    });

    unifiedObserver.observe(collectionContainer, {
      childList: true,
      subtree: true,
    });
  }

  // ==========================================================================
  // 6. INTERCEPT SHOPIFY FORM SUBMISSION FOR HEART SORT
  // ==========================================================================
  /**
   * Pigułki z chmury tagów to zwykłe odsyłacze — żyją wyłącznie w adresie, a formularz Dawn ich nie zna
   * (zmierzone: 44 z 77 tagów nie ma w nim odpowiednika). Bez przeniesienia zmiana sortowania kasowała
   * wybrany filtr i wracał cały katalog: „Biel” 62 wzory → 2023 wzory, bez żadnego komunikatu.
   * Przenosimy TYLKO te pary, których formularz nie potrafi wyrazić — inaczej odznaczenie pola
   * w panelu filtrów nigdy by nie zadziałało, bo stara wartość wracałaby z adresu.
   */
  function wartosciFormularza() {
    const mapa = new Map();
    document.querySelectorAll('facet-filters-form [name^="filter."]').forEach(pole => {
      if (!mapa.has(pole.name)) mapa.set(pole.name, new Set());
      mapa.get(pole.name).add(pole.value);
    });
    return mapa;
  }

  function przeniesFiltryZAdresu(zAdresu, doWyslania) {
    const znane = wartosciFormularza();
    zAdresu.forEach((wartosc, klucz) => {
      if (klucz.indexOf('filter.') !== 0) return;
      // Zakresy ceny są w pełni sterowane przez pola formularza, także gdy klient je czyści.
      if (/\.(gte|lte)$/.test(klucz)) return;
      const wartosciKlucza = znane.get(klucz);
      if (wartosciKlucza && wartosciKlucza.has(wartosc)) return;
      if (doWyslania.getAll(klucz).includes(wartosc)) return;
      doWyslania.append(klucz, wartosc);
    });
  }

  function interceptSortForm() {
    // Nakladka wchodzi TAKZE na nowym listingu: to ona przenosi filtry z chmury tagow przez zmiane
    // sortowania. Samo zdejmowanie wlasnej wartosci sortowania jest nizej i tam strażnik dziala.
    document.querySelectorAll('facet-filters-form').forEach(facetForm => {
      if (facetForm._heartIntercepted || typeof facetForm.onSubmitForm !== 'function') return;
      facetForm._heartIntercepted = true;
      const originalSubmit = facetForm.onSubmitForm;
      facetForm.onSubmitForm = function(searchParams, event) {
        // Własne sortowanie nie jest wartością Shopify. Usuwamy tylko tę wartość,
        // ale normalnie wysyłamy filtry, wyszukiwane hasło i pozostałe parametry.
        const params = new URLSearchParams(searchParams);
        const current = new URLSearchParams(window.location.search);
        // Formularze Dawn nie zawierają typu wyników podanego w adresie wyszukiwania.
        if (current.has('type') && !params.has('type')) params.set('type', current.get('type'));
        przeniesFiltryZAdresu(current, params);
        if (!isDcmCollection() && params.getAll('sort_by').includes(HEART_SORT_VALUE)) params.delete('sort_by');
        return originalSubmit.call(this, params.toString(), event);
      };
    });
  }

  // ==========================================================================
  // INIT
  // ==========================================================================
  function initAll() {
    highlightActiveFilters();
    injectHeartSortOption();
    interceptSortForm();
    listenForHeartCounts();
    observeForChanges();
    window.addEventListener('popstate', syncSortFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
